import { Pill } from '@/shared/components';
import type { UserAccessPreviewResponse, UserAccessPropertySourceResponse } from '@/shared/api';

const SOURCE_LABELS: Record<UserAccessPropertySourceResponse['kind'], string> = {
  direct: 'direkt',
  company: 'Firma',
  team: 'Team',
};

function EffectiveProperties({ preview }: { preview: UserAccessPreviewResponse | undefined }) {
  if (!preview) return <p className="text-ink-faint text-sm">Vorschau wird vorbereitet…</p>;
  if (preview.isUnrestricted) {
    return <p className="text-ink text-sm">Diese Rolle sieht den gesamten Workspace.</p>;
  }
  if (preview.effectiveProperties.length === 0) {
    return <p className="text-ink-soft text-sm">Keine wirksame Apartmentfreigabe.</p>;
  }
  return (
    <ul className="border-line/50 divide-line/50 overflow-hidden rounded-md border">
      {preview.effectiveProperties.map((property) => (
        <li
          key={property.id}
          className="flex min-w-0 items-center justify-between gap-3 px-3 py-2.5"
        >
          <span className="text-ink min-w-0 truncate text-sm">{property.name}</span>
          <span className="flex shrink-0 gap-1">
            {property.sources.map((source) => (
              <Pill key={source.kind} variant="default" size="sm">
                {SOURCE_LABELS[source.kind]}
              </Pill>
            ))}
          </span>
        </li>
      ))}
    </ul>
  );
}

export function UserAccessEffectivePreview({
  preview,
  unavailable,
}: {
  preview: UserAccessPreviewResponse | undefined;
  unavailable: boolean;
}) {
  return (
    <section className="border-line/50 border-t pt-4" aria-live="polite">
      <p className="text-ink-soft text-xs font-medium uppercase tracking-wider">
        Effektive Vorschau
      </p>
      <p className="text-ink-soft mt-1 text-sm">
        Der Server löst die ausgewählten Quellen und vorhandene Teamfreigaben auf.
      </p>
      <div className="mt-3">
        {unavailable ? (
          <p className="text-sealwax text-sm">
            Die Vorschau ist nicht verfügbar. Bitte Eingaben prüfen oder die Akte neu laden.
          </p>
        ) : (
          <EffectiveProperties preview={preview} />
        )}
      </div>
    </section>
  );
}
